// extracted by mini-css-extract-plugin
export default {"wrapper":"Panel_wrapper__LolNK","header":"Panel_header__SQjIA","close":"Panel_close__UfDnZ"};